var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { InView } from 'react-intersection-observer';
import { FunctionColor } from '@lux/text';
import { TitlePreset } from '@lux/title';
import { Translate, TranslateScope } from '@pegasus/translation';
import { CardsSkeletonLoader, ErrorBoundary } from '@browsing/components';
import { Button, ButtonColor, ButtonType } from '@lux/buttons';
import { trackSelectContent } from '@browsing/tracking';
import { Carousel } from './carousel';
import * as S from './styles';
import { useTopPick4U } from './use-top-pick4U';
import { ErrorCard } from './error-card';
var TopPicks4UInternal = function (_a) {
    var gender = _a.gender, profileFashionPreference = _a.profileFashionPreference, selectedFashionPreference = _a.selectedFashionPreference;
    var _b = useTopPick4U({
        gender: gender,
        profileFashionPreference: profileFashionPreference,
        selectedFashionPreference: selectedFashionPreference,
    }), topPicks4U = _b[0], loading = _b[1], error = _b[2];
    var _c = useState(false), inView = _c[0], setInView = _c[1];
    var trackFirstSeeAllClick = function () {
        trackSelectContent('tp4u_banner', 'click', { contentId: 'see_all_first' });
    };
    var onViewChange = function (isInView) {
        if (isInView) {
            setInView(isInView);
        }
    };
    return (React.createElement(TranslateScope, { path: "myLounge.TP4U" },
        React.createElement(InView, { as: "div", onChange: onViewChange, triggerOnce: true },
            React.createElement(S.TopPicksContainer, null,
                React.createElement(S.DetailsWrapper, null,
                    React.createElement(S.DetailsContainer, { onClick: trackFirstSeeAllClick, href: "/campaigns/top-picks/articles" },
                        React.createElement(S.StyledHeadline, { id: "top-picks-headline", preset: TitlePreset.S, color: FunctionColor.function0 },
                            React.createElement(Translate, { message: "headline" })),
                        React.createElement(S.StyledTextLink, null,
                            React.createElement(Button, { as: "span", buttonType: ButtonType.tertiary, color: ButtonColor.bright },
                                React.createElement(Translate, { message: "cta" }))))),
                React.createElement(S.CarouselWrapper, null,
                    loading && (React.createElement(S.CardLoaderWrapper, null,
                        React.createElement(CardsSkeletonLoader, { width: 185, itemsCount: 6, cardHeight: 320 }))),
                    !loading && !error && (React.createElement(Carousel, { carouselItems: topPicks4U, isInView: inView })),
                    error && React.createElement(ErrorCard, null))))));
};
export var TopPicks4U = function (props) { return (React.createElement(ErrorBoundary, { componentName: "TopPicks4U" },
    React.createElement(TopPicks4UInternal, __assign({}, props)))); };
